<template>
  <div class="QuestionsAndAnswers">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>

    <el-form-item label="参考答案" required>
        <uEditor :content="formData.referenceanswer" ref="referenceanswer" @getUEditorContent="getUEditorContent"></uEditor>
    </el-form-item>

    <el-form-item label="试题解析">
        <uEditor :content="formData.quesanalysis" ref="quesanalysis" @getUEditorContent="getUEditorQuesanalysisContent"></uEditor>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor4'
export default {
  name: 'QuestionsAndAnswers',
  props: ['formData'],
  data () {
    return {
        form: {
            subject: '',   // 试题题干Html
            referenceanswer: '', // 参考答案
            quesanalysis: '' // 试题解析
        },
    }
  },
  mounted () {
  },
  methods: {
    getUEditorContent(content) {
        this.formData.referenceanswer = content
    },
    getUEditorSubjectContent(content) {
        this.formData.subject = content
    },
    cancel() {  // 返回题库
        this.$emit('cancel')
    },
    getUEditorQuesanalysisContent(content) {
        this.formData.quesanalysis = content
    },
    submit() {
        if (this.formData.referenceanswer == '') {
            this.$message.error('参考答案不能为空')
            return
        }
        // 传数据给父元素
        this.$emit('childSubmitFormApi', JSON.stringify(this.formData))
    }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      UEditor
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.QuestionsAndAnswers {
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .del {
        position: absolute;
        top: 0;
        right: -20px;
        cursor: pointer;
        img {
            width: 12px;
            height: 12px;
        }
    }
}
</style>
